module.exports = __webpack_public_path__ + "static/media/image2.8a56aa9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/preConference/image2.jpg
// module id = 1130
// module chunks = 0